export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/wxc-tab-page/index.js